import { OnboardingContentWrapper } from "components/Docs/OnboardingContentWrapper";
import { SpanEvent } from "onboarding/llm-analytics/_snippets/span-event.tsx";
import * as React from 'react';
export default {
  OnboardingContentWrapper,
  SpanEvent,
  React
};